import { c as _c } from "react/compiler-runtime";
import type { ComponentProps } from 'react';
import NextLink from 'next/link';
export interface ExternalLinkProps extends ComponentProps<typeof NextLink> {
  underlined?: boolean;
}
export const ExternalLink = t0 => {
  const $ = _c(8);
  let props;
  let underlined;
  if ($[0] !== t0) {
    ({
      underlined,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = underlined;
  } else {
    props = $[1];
    underlined = $[2];
  }
  const t1 = underlined ? "underline" : undefined;
  let t2;
  if ($[3] !== t1) {
    t2 = {
      textDecoration: t1
    };
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== props || $[6] !== t2) {
    t3 = <NextLink target="_blank" rel="noreferrer noopener" style={t2} {...props} prefetch={false} />;
    $[5] = props;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};